<template>
  <v-card>
    <v-card-text>
      <v-text-field v-model="search" label="Course Search" prepend-inner-icon="fal fa-search" outlined hide-details></v-text-field>
      <v-list elevation="1" v-if="count > 0">
        <search-entry v-for="(item, index) in results" :key="'item-' + index" :course="item" :schedule="schedule" @add="$emit('addCourse', item)"></search-entry>
        <v-subheader v-if="count > results.length">{{ count - results.length }} additional entries match; type more to filter</v-subheader>
      </v-list>
      <p v-else-if="search !== ''">There are no courses that match your search.</p>
      <p v-else>Please enter some text in the box above to search. You can search by subject/course number, title, section, and/or day and time.</p>
    </v-card-text>
  </v-card>
</template>
<script>
import { ref, watch } from '@vue/composition-api'
export default {
  props: {
    schedule: {
      type: Array,
      required: true
    }
  },
  components: {
    SearchEntry: () => import('./searchEntry')
  },
  setup (props, { root }) {
    const search = ref('')
    const results = ref([])
    const count = ref(0)

    watch(search, () => {
      if (search.value !== '') {
        let query = { term_code: root.$store.state.term, text: { $like: '%' + search.value.replaceAll(' ', '%') + '%' }, $limit: 5 }
        root.$feathers.service('warehouse/courses').find({ query }).then(({ data, total }) => {
          results.value = data
          count.value = total
        })
      } else {
        results.value = []
        count.value = 0
      }
    })

    return {
      search,
      results,
      count
    }
  }
}
</script>
